export default __webpack_public_path__ + "static/media/icon_training.b7af65f1.svg";